import { type FC, memo } from "react";
import dayjs from "dayjs";
import { Text } from "@stubhub/broadway-web";
import { useFormattedEventDateTime } from "@stubhub/ensemble-discovery";
import type { EventListGridItem } from "src/http/types";
import { Content } from "src/shared/components/content";
import { formatDateString } from "src/website-apps/responsive/stubhub-performer/components/calendar/utils";
import { EventCardMobile } from "./EventCardMobile";

interface Props {
  events?: EventListGridItem[];
  primaryColor?: string | undefined;
  openNotificationHandler: (eventId: number) => void;
}

export const MlbDateCardMobileBody: FC<Props> = memo(({ events = [], primaryColor, openNotificationHandler }) => {
  const [primaryEvent] = events;
  const { dateHeader } = useFormattedEventDateTime(
    primaryEvent?.eventMetadata?.common?.eventStartDateTime,
    primaryEvent?.eventMetadata?.common?.eventEndDateTime ?? undefined,
    primaryEvent?.eventMetadata?.common?.venueTimeZoneOffset,
    primaryEvent?.onSaleDateTimeData?.onSaleDateTime
      ? dayjs(primaryEvent.onSaleDateTimeData.onSaleDateTime).unix() * 1000
      : undefined,
    primaryEvent?.eventMetadata?.common?.passLength ?? undefined,
  );

  if (!primaryEvent) {
    // This scenario should never happen
    return null;
  }

  // Create data-date attribute for scroll sync (YYYY-MM-DD format)
  const eventDate = new Date(primaryEvent.dateTime ?? "");
  const dateString = formatDateString(eventDate);
  return (
    <div data-date={dateString}>
      <Text variant="label" size="small" style={{ marginBottom: "8px" }}>
        {primaryEvent.isDateConfirmed ? dateHeader : <Content id="cid$#3998409#" /** To Be Announced */ />}
      </Text>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {events.map((event) => (
          <EventCardMobile
            key={event.eventId}
            event={event}
            primaryColor={primaryColor}
            openNotificationHandler={openNotificationHandler}
          />
        ))}
      </div>
    </div>
  );
});
MlbDateCardMobileBody.displayName = "MlbDateCardMobileBody";
